import { useMemo } from 'react';
import {
  calculateDropoffAreaFlg,
  calculatePickupAreaFlg,
  calculatePickupDropoffAreaFlg,
} from '@/components/pages/drive/details/driveDetailsMarkerUtils';
import type { DropoffInformationType } from '@/features/map/types/dropoffInformationType';
import type { PickupDropoffInformationType } from '@/features/map/types/pickupDropoffInformationType';
import type { PickupInformationType } from '@/features/map/types/pickupInformationType';

type UseDriveDetailsHelpersParams = {
  pickupInformation: PickupInformationType[];
  dropoffInformation: DropoffInformationType[];
  pickupDropoffInformation: PickupDropoffInformationType[];
};

type UseDriveDetailsHelpersReturn = {
  pickupAreaFlg: 1 | 2;
  dropoffAreaFlg: 1 | 2;
  pickupDropoffAreaFlg: 1 | 2;
};

export const useDriveDetailsHelpers = ({
  pickupInformation,
  dropoffInformation,
  pickupDropoffInformation,
}: UseDriveDetailsHelpersParams): UseDriveDetailsHelpersReturn => {
  const pickupAreaFlg = useMemo(() => calculatePickupAreaFlg(pickupInformation), [pickupInformation]);
  const dropoffAreaFlg = useMemo(() => calculateDropoffAreaFlg(dropoffInformation), [dropoffInformation]);
  const pickupDropoffAreaFlg = useMemo(
    () => calculatePickupDropoffAreaFlg(pickupDropoffInformation),
    [pickupDropoffInformation],
  );

  return { pickupAreaFlg, dropoffAreaFlg, pickupDropoffAreaFlg };
};
